module.exports = __webpack_public_path__ + "img/BlinkArt_Sword1_Bronze.b4c7d5e2.png";